<script>
    import PropertyListing from "../components/PropertyListing.svelte";
    import PropertyListView from '../components/PropertyListView.svelte';
    import Modal from "../components/Modal.svelte";
    import MonthRangeInput from "../components/MonthRangeInput.svelte";
    import TextFilters from "../components/TextFilters.svelte";
    import PaginationControls from "../components/PaginationControls.svelte";
    import fetchNode from "../helpers/FetchNode.js";
    import filterByAvailability from "../helpers/filterByAvailability.js";
    import standardizeDate from "../helpers/standardizeDate.js";
    import { onMount } from 'svelte';
    import { DateTime } from 'luxon';

    export let user;

    let propertyAvailability = [];
    let propertiesParams = {};
    let columnSelected;
	  let listViewPage = 1;
    let searchTerm;
    let dropdownSelected = "All";
    let propertiesListView;
    let currentView = 0;
    let emptyArray = 0;
    let propertiesListRequest = [];


    const apiNode = user && user.airbetterRoleId !== 1 ? 'account/' + user.account.id + '/properties' : 'property';

    //Pagination Options
    let limit = 10;
    let page = 1;
    //Initial Date Range
    let dateRange = {
      start: DateTime.utc().startOf('day').toJSDate(),
      end: DateTime.utc().startOf('day').plus({ months: 1 }).toJSDate()
    };
    //Initial Availability Filter
    let availability = 'all';

    $: propertiesRequest = fetchNode(apiNode, {limit:200, where: JSON.stringify(propertiesParams)}).then(properties => filterByAvailability(properties,propertyAvailability,availability));
    $: fetchNode('property/availability',{ start: standardizeDate(dateRange.start) , end: standardizeDate(dateRange.end) }).then(r=>propertyAvailability = r);
</script>
<div class="card dash-controls">
  <TextFilters
    bind:searchTerm='{searchTerm}'
    bind:columnSelected='{columnSelected}'
    bind:propertiesListRequest={propertiesListRequest}
    bind:propertiesListView={propertiesListView}
    bind:params={propertiesParams}
    bind:dateRange={dateRange}
    bind:availability={availability} currentView={currentView}
    bind:page='{listViewPage}'
    bind:emptyArray={emptyArray}
  />
</div>

{#await propertiesRequest then properties}
  <PaginationControls
    bind:limit='{limit}'
    bind:page='{page}'
    bind:currentView='{currentView}'
    count='{properties.length}'
    dateRange={dateRange}
    user={user}
  />
  {#if currentView === 0}
    <div class='card' id='property-listing'>
      <PropertyListing
        properties='{properties}'
        dateRange={dateRange}
        limit={limit}
        page='{page}'
        availability='{propertyAvailability}'
      />
    </div>
  {/if}
{/await}
{#if currentView === 1}
<div class='card list-view' id='list-view'>
  <PropertyListView
    propertiesListRequest={propertiesListRequest}
    bind:propertiesListView={propertiesListView}
    bind:columnSelected='{columnSelected}'
    bind:searchTerm='{searchTerm}'
    bind:listViewPage='{listViewPage}'
    bind:emptyArray={emptyArray}
    dateRange={dateRange}
    limit={limit}
    availability='{propertyAvailability}'
    user={user}
  />
</div>
{/if}

{#if user.accountRole.toLowerCase()!="cleaner"}
  <Modal/>
{/if}
<style>

/* Controls */

.dash-controls{
  display: flex;
}

.list-view{
  overflow-x: scroll;
}
</style>